export enum HttpStatusEnum {
  notFound = '404',
  serverError = '500',
}
